export const SETTINGS = {
  BUDGET_TYPE: "BudgetType",
  PROCUREMENT_TYPE: "ProcurementType",
  PROCUREMENT_METHOD: "ProcurementMethod",
  PROCUREMENT_NATURE: "ProcurementNature",
};
